<script lang="ts">
  import { AppState } from '../../etc/stores';
  import { createEventDispatcher, onDestroy } from 'svelte';
  import CoinIcon from '../icons/Coin.svelte';
  import { isIOS, isMobile } from '../../etc/utils';

  const dispatch = createEventDispatcher();

  export let name;
  export let autoFocus = undefined;
  export let placeholder = undefined;
  export let input = undefined;
  export let value;
  export let maxLength = undefined;
  export let readonly = undefined;
  export let disabled = undefined;
  export let disableFocusScrollIOS = false;

  let isFocused = false;

  let leftCoin = 0;
  let timeout;
  let elementPopover = null;

  $: {
    elementPopover = document.querySelector('.twism-popover') as HTMLDivElement;
    leftCoin = 2.5 * value.toString().length;
  }

  const onFocus = () => {
    isFocused = true;
    dispatch('focus', isFocused);
    if (isMobile() && isIOS() && disableFocusScrollIOS) {
      elementPopover.style.transform = 'translateY(148px)';
      window.scrollTo({ top: 148, left: 0 });
      timeout = setTimeout(() => {
        elementPopover.style.removeProperty('transform');
        window.scrollTo({ top: 0, left: 0 });
      }, 300);
    }
  };

  const onBlur = () => {
    isFocused = false;
    dispatch('focus', isFocused);
    if (isMobile() && isIOS() && disableFocusScrollIOS) {
      elementPopover.style.removeProperty('transform');
    }
  };

  function handleInput(e) {
    e.target.value = e.target.value.replace(',', '.');

    const newValue = e.target.value.replace(/[^0-9\.]+/g, '');

    if (newValue.toString().length <= maxLength) {
      value = newValue;
      dispatch('input', newValue);
    }
  }

  onDestroy(() => {
    clearTimeout(timeout);
  });
</script>

<label class="input" for={name}>
  <div class="input__container">
    <div
      class={'input__coin'}
      style={`left: calc(50% - 22px - ${leftCoin}px);`}
    >
      <slot {isFocused} name="icon">
        <CoinIcon
          size={18}
          stroke={isFocused ? $AppState.theme.colors.secondary : '#bcc0c4'}
        />
      </slot>
    </div>
    <input
      bind:this={input}
      on:input={handleInput}
      on:focus={onFocus}
      on:blur={onBlur}
      class="input__field"
      id={name}
      inputmode="decimal"
      pattern="[0-9]*"
      autofocus={autoFocus}
      autocomplete="off"
      {name}
      {placeholder}
      {value}
      {maxLength}
      {readonly}
      {disabled}
    />
  </div>
</label>

<style lang="scss">
  .input {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    align-items: center;
    justify-content: center;

    &__field {
      border: 1px solid #e4ebf2;
      border-radius: 8px;
      font-size: 16px;
      line-height: 16px;
      padding: 16px;
      color: $color-big-stone;
      transition: border-color 0.2s ease-in-out;
      text-align: center;
      align-self: center;
      width: 100%;
      box-sizing: border-box;

      &::placeholder {
        color: #90989f;
      }
      &:focus {
        border-color: var(--twism-theme-secondary);
        outline: none !important;
      }
    }
    &__container {
      position: relative;
      width: 100%;
    }
    &__coin {
      display: flex;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      align-items: center;
      justify-content: center;
    }
  }
</style>
